import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message = _resolveComponent("message")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Social Platform Disabled",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_message, { type: "info" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.socialSite.name) + " connection is currently disabled. Please try again later. ", 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}